import gsap from "gsap";
import SplitText from 'gsap/SplitText';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrollTrigger);

$('body').on('initScripts', function() {
    let animDuration = 0.5;

    const $body = $('body');

    if (!prefersReducedMotion) {
        const $masthead = $('header.masthead .masthead__inner');
        const headings = gsap.utils.toArray('.heading-split');
        const images = gsap.utils.toArray('.full-width-media--transition-to-viewport-width');

        // prepare masthead
        gsap.set($masthead, { yPercent: -100 });

        $body.on('pageLoaderHidden pageTransitionComplete', function () {
            gsap.to($masthead, {
                duration: animDuration,
                ease: 'power2.out',
                yPercent: 0,
                onComplete: () => gsap.set($masthead, { clearProps: 'all' })
            });

            headings.forEach(heading => {
                // prepare split text (FUOT)
                gsap.set(heading, {
                    opacity: 1
                });

                SplitText.create(heading, {
                    type: 'lines',
                    mask: 'lines',
                    autoSplit: true,
                    onSplit: (self) => {
                        return gsap.from(self.lines, {
                            duration: animDuration * 2,
                            ease: 'power2.inOut',
                            y: 100,
                            opacity: 0,
                            stagger: 0.1,
                            onComplete: () => self.revert(),
                            scrollTrigger: {
                                trigger: heading,
                                start: 'top 125%',
                            }
                        });
                    },
                });
            });

            images.forEach(image => {
                gsap.set(image, {
                    left: '50%',
                    translateX: '-50%'
                });

                const transition = gsap.timeline({paused: true});

                transition.to(image, {
                    width: $('.page-content').width(),
                    ease: 'none'
                });

                ScrollTrigger.create({
                    trigger: image,
                    start: '20% bottom',
                    end: 'bottom bottom',
                    animation: transition,
                    scrub: true,
                });
            })
        });
    }
});
